module.exports = __webpack_public_path__ + "x2.png";